import { CircleHelp } from 'lucide-react';
import type { ButtonHTMLAttributes } from 'react';
import { cx } from '../cx.js';

export interface HelpButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  /** `intestazione`: nella barra in alto; `compatto`: accanto al titolo di una scheda o di un modulo. */
  variant?: 'intestazione' | 'compatto';
  /** Etichetta per lettori di schermo e tooltip. */
  label?: string;
}

/** Bottone con il punto di domanda: apre il manuale sulla sezione della pagina. Area cliccabile 44px. */
export function HelpButton({ variant = 'intestazione', label = 'Apri il manuale', className, ...rest }: HelpButtonProps) {
  return (
    <button
      type="button"
      aria-label={label}
      title={label}
      data-aiuto={variant}
      className={cx(
        'inline-flex items-center justify-center rounded-md transition-colors duration-150 h-11 w-11 shrink-0',
        variant === 'intestazione' ? 'text-ink-muted hover:text-ink hover:bg-surface-sunken' : 'text-accent hover:text-accent-strong hover:bg-accent-soft',
        className,
      )}
      {...rest}
    >
      <CircleHelp aria-hidden size={variant === 'intestazione' ? 20 : 18} strokeWidth={1.75} />
    </button>
  );
}
